<template>
  <div class="pdp-tldr-container">
    <div class="d-flex align-items-center">
      <h4 class="pdp-section-header d-inline mr-2 my-0 h3">
        TL;DR
      </h4>
      <TooltipIcon tooltip-text="Too Long; Didn't Read" tooltip-id="tldr-tooltip" />
    </div>
    <div class="pdp-tldr-body">
      <div
        v-for="(highlight, tIndex) in highlights"
        :key="`highlight-${tIndex}`"
        class="pdp-tldr-highlight"
      >
        <div>
          {{ highlight.highlight }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TooltipIcon from '~/components/common/TooltipIcon.vue';

export default {
  components: {
    TooltipIcon,
  },
  props: {
    highlights: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../styles/utils/breakpoints';

  .pdp-tldr-body {
    background-color: #f5f5f9;
    border-radius: 4px;
    margin-top: 16px;
    padding: 8px 16px;
  }

  .pdp-tldr-highlight {
    border-bottom: 1px solid #c7ced7;
    font-size: 16px;
    line-height: 24px;
    padding: 8px 0;

    &:last-child {
      border-bottom: 0;
    }
  }

  @include media-breakpoint-up(md) {
    .pdp-tldr-body {
      padding-bottom: 0;
      padding-top: 0;
    }

    .pdp-tldr-highlight {
      padding: 16px 0;
    }
  }
</style>
